import { createFormAction } from 'redux-form-saga';
import * as substanceTRFormTypes from './substanceTRFormTypes';

export const submitSubstanceTRForm = createFormAction(substanceTRFormTypes.SUBMIT_SUBSTANCE_TR_FORM);
